//대시보드
import React, { useState, useEffect, useCallback } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { palette } from "../../../assets/styles/Palette";
import {
  Body1,
  Body2,
  Caption1,
  Sub2,
} from "../../../assets/styles/Typography";
import { Button } from "../../../assets/styles/ButtonStyle";
import MoleculeHeader from "../../Global/components/molecules/MoleculeHeader";
import { useAtom } from "jotai";
import {
  IS_LOGGED_IN,
  AUTODISPLAY_SELECTED_DEVICE,
  AUTODISPLAY_DISPLAY_LIST,
  AUTODISPLAY_CONTENT_LIST,
  CUSTOMER_ID,
  CUSTOMER_NAME,
  CUSTOMER_DETAIL,
} from "../../AtomStates";
import OrganismDashboardDisplayList from "../components/organisms/OrganismDashboardDisplayList";
import OrganismDashboardContentList from "../components/organisms/OrganismDashboardContentList";
import PopupWrap from "../../../assets/styles/Popup";
import {
  SelectBox,
  SelectBoxTitle,
  SelectBoxList,
  SelectBoxItem,
  CustomTextarea,
  CheckBoxButton,
} from "../../../assets/styles/InputStyle";
import images from "../../../assets/styles/Images";
import {
  createDisplayOnServer,
  updateDisplayOnServer,
  getDisplayListOnServer,
  getDisplayListCustomerOnServer,
  getViewListOnServer,
  getViewListCustomerOnServer,
  getUserMemberType,
  getUserInfo,
  getCustomerDetailOnServer,
} from "../../../utils/indexedDB";
import AutodisplaySelectedPopup from "../components/molecules/AutodisplaySelectedPopup";
import {
  TabWrapType3,
  TabButtonType3,
} from "../../../assets/styles/BusinessAnalysisStyle";

const PageDashBoard = () => {
  const navigate = useNavigate();

  // 대시보드 상태 데이터
  const [stats] = useState({
    displayList: 5,
    totalContent: 20,
    activeContent: 10,
    credits: 21250,
  });
  const [activeTab, setActiveTab] = useState("content");
  // 팝업 관련 상태
  const [isLoggedIn, setIsLoggedIn] = useAtom(IS_LOGGED_IN);
  const [selectedDevice, setSelectedDevice] = useAtom(
    AUTODISPLAY_SELECTED_DEVICE
  );
  const [customerId, setCustomerId] = useAtom(CUSTOMER_ID);
  const [customerName, setCustomerName] = useAtom(CUSTOMER_NAME);
  const [customerDetail, setCustomerDetail] = useAtom(CUSTOMER_DETAIL);
  const [isCustomizePopupOpen, setIsCustomizePopupOpen] = useState(false);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [isSelectDisplayPopupOpen, setIsSelectDisplayPopupOpen] =
    useState(false);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [addDisplayForm, setAddDisplayForm] = useState({
    deviceTitle: "",
    deviceLocation: "",
    deviceTarget: "",
    deviceSpec: {
      deviceWidth: "",
      deviceHeight: "",
      deviceWidthMM: "",
      deviceHeightMM: "",
      deviceCm: "",
      deviceResolution: "",
      deviceDPI: "",
      deviceInch: "",
    },
  });
  const [activateCount, setActivateCount] = useState(0);
  const [selectBoxStates, setSelectBoxStates] = useState({
    deviceDPI: false,
    deviceInch: false,
  });
  const [showDeviceSelectPopup, setShowDeviceSelectPopup] = useState(false);
  const [isTypingDPI, setIsTypingDPI] = useState(false);
  const [isTypingInch, setIsTypingInch] = useState(false);
  const [displayList, setDisplayList] = useAtom(AUTODISPLAY_DISPLAY_LIST);
  const [contentList, setContentList] = useAtom(AUTODISPLAY_CONTENT_LIST);
  const [newDisplayId, setNewDisplayId] = useState(null);
  const [selectedEditDisplayId, setSelectedEditDisplayId] = useState(null);

  // 고객사 정보를 불러오는 함수
  const fetchCustomerDetail = async () => {
    const customerIdFromStorage = sessionStorage.getItem("customerId") || "";
    setCustomerId(customerIdFromStorage);
    if (customerIdFromStorage !== "") {
      try {
        const customerDetailResponse = await getCustomerDetailOnServer(
          customerIdFromStorage,
          isLoggedIn
        );
        if (customerDetailResponse) {
          setCustomerDetail(customerDetailResponse);
        }
      } catch (error) {
        console.error("고객사 정보를 불러오는 중 오류가 발생했습니다:", error);
      }
    }
  };

  useEffect(() => {
    const checkMemberType = async () => {
      const accessToken = sessionStorage.getItem("accessToken");
      const userMemberType = await getUserMemberType(accessToken);

      const lastUrl = sessionStorage.getItem("lastUrl");

      const currentUrl = window.location.href;
      sessionStorage.setItem("lastUrl", currentUrl);

      fetchCustomerDetail();

      if (
        (lastUrl === "/ApiDashBoard" || lastUrl === "/CreateApiContent") &&
        userMemberType.member_type === 99
      ) {
        navigate("/Admin");
      }

      if (userMemberType.member_type === 21) {
        navigate("/ApiDashBoard");
      } else if (userMemberType.member_type === 22) {
        navigate("/CustomerManage");
      } else if (userMemberType.member_type === 31) {
        navigate("/EducationDashBoard");
      } else if (userMemberType.member_type === 32) {
        navigate("/EduboardManage");
      }
    };

    checkMemberType();
  }, []);

  // 데이터 fetching 함수 분리
  const fetchContentList = async () => {
    if (!isLoggedIn) {
      return; // 로그인 상태가 아니면 API를 호출하지 않음
    }

    try {
      let response;
      const accessToken = sessionStorage.getItem("accessToken");
      const memberType = await getUserMemberType(accessToken);
      const customerIdFromStorage = sessionStorage.getItem("customerId") || "";

      if (
        customerIdFromStorage === "" &&
        (memberType.member_type === 11 || memberType.member_type === 21)
      ) {
        response = await getDisplayListOnServer(10, 1, isLoggedIn);
        setDisplayList(response.data);
      } else {
        response = await getDisplayListCustomerOnServer(
          customerIdFromStorage,
          999,
          1,
          isLoggedIn
        );
        setDisplayList(response.data);
      }

      let viewList;

      if (
        customerIdFromStorage === "" &&
        (memberType.member_type === 11 || memberType.member_type === 21)
      ) {
        viewList = await getViewListOnServer(10, 1, isLoggedIn);
        setContentList(viewList.data);
        setActivateCount(viewList.activate_count);
      } else {
        viewList = await getViewListCustomerOnServer(
          customerIdFromStorage,
          999,
          1,
          isLoggedIn
        );

        setContentList(viewList.data);
        setActivateCount(viewList.activate_count);
      }

      setContentList(viewList.data);
    } catch (error) {
      console.error("콘텐츠 리스트를 불러오는 중 오류가 발생했습니다:", error);
    }
  };

  const fetchCompanyName = async () => {
    const accessToken = sessionStorage.getItem("accessToken");
    // const memberType = await getUserMemberType(accessToken);
    if (customerId === "") {
      const userInfo = await getUserInfo(accessToken);
      setCustomerName(userInfo.organization_name);
    }
  };

  useEffect(() => {
    fetchContentList();
    fetchCompanyName();
  }, [isLoggedIn]);

  const handleCustomizePopupClose = () => {
    setIsCustomizePopupOpen(false);
    setActiveTabIndex(0);
    setAddDisplayForm({
      deviceTitle: "",
      deviceLocation: "",
      deviceTarget: "",
      deviceSpec: {
        deviceWidth: "",
        deviceHeight: "",
        deviceCm: "",
        deviceResolution: "",
        deviceDPI: "",
        deviceInch: "",
      },
    });
  };

  const handleCustomizePopupConfirm = () => {
    if (activeTabIndex < 2) {
      setActiveTabIndex(activeTabIndex + 1);
    } else {
      // 마지막 탭에서 확인
      // console.log("기기 등록 완료", addDisplayForm);
      handleCustomizePopupClose();
    }
  };

  const toggleSelectBox = (type) => {
    setSelectBoxStates((prev) => ({
      ...prev,
      [type]: !prev[type],
    }));
  };

  const handleFormChange = useCallback((field, value) => {
    setAddDisplayForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  }, []);

  const isFormValid = () => {
    const deviceDPIValid =
      addDisplayForm.deviceDPI &&
      (addDisplayForm.deviceDPI !== "기타" || addDisplayForm.deviceInch);

    return (
      addDisplayForm.deviceTitle &&
      addDisplayForm.deviceLocation &&
      addDisplayForm.deviceTarget &&
      deviceDPIValid &&
      addDisplayForm.deviceInch &&
      addDisplayForm.deviceSpec.deviceWidth &&
      addDisplayForm.deviceSpec.deviceHeight
    );
  };

  // AutodisplaySelectedPopup에서 기기 선택 시
  const handleAutoDisplaySelect = (selectedDisplayId) => {
    const originalDevice = displayList.find((d) => d._id === selectedDisplayId);
    // console.log("originalDevice", originalDevice);
    if (originalDevice) {
      setSelectedDevice(originalDevice);
      setShowDeviceSelectPopup(false);
      navigate("/CreateContent", { state: { selectedDevice: originalDevice } });
    }
  };

  const handleAutoDisplayClose = () => {
    setShowDeviceSelectPopup(false);
  };

  const handleSaveNewDisplay = async (displayData) => {
    try {
      // customerId가 있으면 displayData에 추가
      if (customerId !== "") {
        displayData.customer = customerId;
      }
      // 1. 먼저 새 디스플레이 ID를 생성
      const newDisplayId = await createDisplayOnServer(isLoggedIn);

      if (!newDisplayId) {
        throw new Error("디스플레이 ID 생성에 실패했습니다.");
      }

      // 2. 생성된 ID에 디스플레이 정보를 업데이트
      await updateDisplayOnServer(newDisplayId, displayData);

      // 3. 디스플레이 목록 새로고침
      await fetchContentList();
    } catch (error) {
      console.error("새 디스플레이 저장 실패:", error);
      throw error; // AutodisplaySelectedPopup에서 에러 처리하도록 전달
    }
  };

  // const handleDomainKeyGenerate = async () => {
  //   try {
  //     const createDisplayId = await createDisplayOnServer(isLoggedIn);
  //     // 성공 시 후속 처리, 예를 들어 팝업을 닫거나 상태 업데이트
  //     const response = await updateDisplayOnServer(
  //       createDisplayId,
  //       addDisplayForm
  //     );

  //     // 도메인 키 생성 성공 후 데이터 다시 불러오기
  //     await fetchContentList();
  //   } catch (error) {
  //     console.error("도메인 키 생성 오류:", error);
  //     // 실패 시 에러 처리
  //   } finally {
  //     setIsCustomizePopupOpen(false);
  //     handleCustomizePopupClose();
  //   }
  // };

  // 사이즈 계산 로직
  useEffect(() => {
    const { deviceDPI, deviceInch } = addDisplayForm.deviceSpec;

    if (!deviceDPI || !deviceInch) return;

    try {
      const resolutionMatch = deviceDPI.match(/(\d{3,})\s*[×x*]\s*(\d{3,})/);
      const inchMatch = deviceInch.match(/(\d+(\.\d+)?)/);

      if (!resolutionMatch || !inchMatch) return;

      const widthPx = parseInt(resolutionMatch[1], 10);
      const heightPx = parseInt(resolutionMatch[2], 10);
      const diagonalInch = parseFloat(inchMatch[1]);

      const aspectRatio = widthPx / heightPx;
      const heightInch = diagonalInch / Math.sqrt(aspectRatio ** 2 + 1);
      const widthInch = heightInch * aspectRatio;

      const widthMm = Math.round(widthInch * 25.4);
      const heightMm = Math.round(heightInch * 25.4);

      setAddDisplayForm((prev) => ({
        ...prev,
        deviceSpec: {
          ...prev.deviceSpec,
          deviceWidth: widthPx.toString(),
          deviceHeight: heightPx.toString(),
          deviceWidthMM: widthMm.toString(),
          deviceHeightMM: heightMm.toString(),
        },
      }));
    } catch (e) {
      console.error("Failed to calculate display size", e);
    }
  }, [
    addDisplayForm.deviceSpec.deviceDPI,
    addDisplayForm.deviceSpec.deviceInch,
  ]);

  const handleCreateContentPopup = () => {
    setShowDeviceSelectPopup(true);
  };

  const handleEditDisplayPopup = (displayId) => {
    setShowDeviceSelectPopup(true);
    setSelectedEditDisplayId(displayId);
  };

  return (
    <DashboardContainer>
      <MoleculeHeader />

      {/* 메인 컨텐츠 */}
      <MainContent>
        {/* 상단 섹션 */}
        <TopSection>
          <CompanyInfo>
            <Avatar />
            <CompanyName>{customerName}</CompanyName>
          </CompanyInfo>
          <ButtonGroup>
            {/* <Button dbExLarge Fill PrimaryLightest onClick={showPopup}>
              <Sub2 color="primary">새 기기 등록</Sub2>
            </Button> */}
            <Button
              Large
              Primary
              Fill
              onClick={() => setShowDeviceSelectPopup(true)}
            >
              <Sub2 color="white">새 콘텐츠</Sub2>
            </Button>
          </ButtonGroup>
        </TopSection>

        {/* 통계 섹션 */}
        <StatsSection>
          <SectionTitle>콘텐츠 활성화 현황</SectionTitle>
          <StatsGrid>
            <StatCard>
              <StatHeader>
                <Body2 color="gray600">총 생성된 콘텐츠 수 (건수) </Body2>
                {/* <Body2 color="gray600">개수</Body2> */}
              </StatHeader>
              <StatValue>{contentList.length} 건</StatValue>
            </StatCard>
            <StatCard>
              <StatHeader>
                <Body2 color="gray600">활성화 중 디스플레이 수 (건수) </Body2>
                {/* <Body2 color="gray600">건수</Body2> */}
              </StatHeader>
              <StatValue>{activateCount ? activateCount : 0} 건</StatValue>
            </StatCard>
            <StatCard>
              <StatHeader>
                <Body2 color="gray600">등록된 디스플레이 수 (갯수) </Body2>
                {/* <Body2 color="gray600">건수</Body2> */}
              </StatHeader>
              <StatCardContent>
                <StatValue>{displayList.length} 개</StatValue>

                <AddDisplayButton
                  onClick={() => setShowDeviceSelectPopup(true)}
                >
                  + 사이즈 등록
                </AddDisplayButton>
              </StatCardContent>
              {/* <Button dbExLarge Fill PrimaryLightest onClick={showPopup}>
              <Sub2 color="primary">새 기기 등록</Sub2>
            </Button> */}
            </StatCard>
          </StatsGrid>
        </StatsSection>
        {/* 탭 및 테이블 섹션 */}

        <TableSection>
          <TabContainer>
            <TabWrapType3>
              <TabButtonType3
                isActive={activeTab === "content"}
                onClick={() => setActiveTab("content")}
              >
                콘텐츠 리스트
              </TabButtonType3>
              {/* <TabButtonType3 isActive={activeTab === 'display'} onClick={() => setActiveTab('display')}>디스플레이 리스트</TabButtonType3> */}
            </TabWrapType3>

            <CustomPopupSubtitle>
              콘텐츠 연결 주소:{" "}
              <ContentLink
                href={`${window.location.origin}/autodisplayView`}
                target="_blank"
                rel="noopener noreferrer"
              >
                autodisplayView
              </ContentLink>
            </CustomPopupSubtitle>
          </TabContainer>

          {activeTab === "content" ? (
            <OrganismDashboardContentList
              handleCreateContent={handleCreateContentPopup}
            />
          ) : (
            <OrganismDashboardDisplayList
              handleEditDisplayPopup={handleEditDisplayPopup}
            />
          )}
        </TableSection>
      </MainContent>

      {/* 기기 없음 알림 팝업 */}

      {/* 기기 선택 팝업 */}
      {showDeviceSelectPopup && (
        <AutodisplaySelectedPopup
          onClose={handleAutoDisplayClose}
          onSelect={handleAutoDisplaySelect}
          onSaveNewDisplay={handleSaveNewDisplay}
          selectedEditDisplayId={selectedEditDisplayId}
        />
      )}

      {/* {showConfirmPopup && (
        <PopupWrap
          Warning
          title="정말 활성화 하시겠습니까?"
          // message={
          //   <>
          //     보유한 크레딧이 부족합니다.
          //     <br />
          //     크레딧을 충전한 후 다시 시도해주세요.
          //   </>
          // }
          buttonType="Outline"
          closeText="취소"
          confirmText="확인"
          isModal={false}
          onCancel={() => {
            setShowConfirmPopup(false);
          }}
          onConfirm={() => {
            setShowConfirmPopup(false);
            handleDomainKeyGenerate();
          }}
        />
      )} */}
    </DashboardContainer>
  );
};

export default PageDashBoard;

// PopupContent 스타일 추가
const PopupContent = styled.div`
  margin-top: 8px;
`;

// 스타일 컴포넌트들
const DashboardContainer = styled.div`
  width: 100%;
  max-width: 2330px;
  margin: 0 auto;
  background: ${palette.white};
  min-height: 100vh;
`;

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 40px;
  height: 56px;
`;

const Logo = styled.h1`
  font-family: Poppins;
  font-weight: 700;
  font-size: 20px;
  color: #323232;
  margin: 0;
`;

const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

const CreditSection = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const CreditIcon = styled.div`
  width: 20px;
  height: 20px;
  background: #ffd54a;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
`;

const CreditText = styled.span`
  font-family: Pretendard;
  font-weight: 500;
  font-size: 14px;
  color: #323232;
`;

const CreditArrow = styled.span`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #cccccc;
`;

const NotificationIcon = styled.div`
  width: 18px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MoreIcon = styled.div`
  width: 18px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #e0e4eb;
`;

const MainContent = styled.main`
  max-width: 1240px;
  margin: 0 auto;
  padding: 72px 0;
  display: flex;
  flex-direction: column;
  gap: 72px;
`;

const TopSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
`;

const CompanyInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Avatar = styled.div`
  width: 48px;
  height: 48px;
  background: #d9d9d9;
  border-radius: 50%;
  background-image: url("/logo192.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

const CompanyName = styled.h2`
  font-family: poppins;
  font-weight: 700;
  font-size: 40px;
  color: #1e2124;
  margin: 0;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 20px;
`;

const StatsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const SectionTitle = styled.h3`
  font-family: Pretendard;
  font-weight: 700;

  font-size: 16px;
  color: #696969;
  margin: 0;
  text-align: left;
`;

const StatsGrid = styled.div`
  display: flex;
  gap: 20px;
`;

const StatCard = styled.div`
  flex: 1;
  background: ${palette.white};
  border: 1px solid #e0e4eb;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const StatHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StatValue = styled.div`
  font-family: Poppins;
  font-weight: 700;

  font-size: 30px;
  color: #666666;
  text-align: left;
`;

const TableSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const TabContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
`;

const TabGroup = styled.div`
  display: flex;
  gap: 8px;
`;

const Tab = styled.button`
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid ${({ active }) => (active ? "#E0E4EB" : "#e0e4eb")};
  background: ${({ active }) => (active ? "#F7F8FA" : "transparent")};
  color: ${palette.gray700};
  font-weight: ${({ active }) => (active ? 600 : 400)};
  font-size: 15px;
  cursor: pointer;
  margin-right: 8px;
  transition: background 0.2s, color 0.2s, border 0.2s;

  &:last-child {
    margin-right: 0;
  }
`;

const Table = styled.div`
  border-radius: 0;
  overflow: hidden;
`;

const TableHeader = styled.div`
  display: flex;
  background: #eef2f7;
`;

const TableBody = styled.div`
  display: flex;
  flex-direction: column;
`;

const TableRow = styled.div`
  display: flex;
  background: ${palette.white};

  &:not(:last-child) {
    border-bottom: 1px solid #cdd1d5;
  }
`;

const HeaderCell = styled.div`
  padding: 20px 16px;
  font-family: Pretendard;
  font-weight: 700;
  font-size: 15px;
  color: #131416;
  border-right: 1px solid #d6e0eb;

  ${(props) =>
    props.wide
      ? `
    flex: 1;
    text-align: left;
  `
      : `
    width: 240px;
    text-align: right;
  `}

  &:last-child {
    border-right: none;
  }
`;

const TableCell = styled.div`
  padding: 20px 16px;
  font-family: Pretendard;
  font-weight: 400;
  font-size: 17px;
  color: #464c53;
  border-right: 1px solid #cdd1d5;

  ${(props) =>
    props.wide
      ? `
    flex: 1;
    text-align: left;
  `
      : `
    width: 240px;
    text-align: right;
  `}

  &:last-child {
    border-right: none;
  }
`;

const PopupFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 0;
`;

const FormField = styled.div`
  display: flex;
  flex-direction: column;
  // gap: 4px;
  flex: ${(props) => props.flex || "none"};
  margin-bottom: -10px;

  Body2 {
    margin-bottom: 10px;
  }
`;

const FormRow = styled.div`
  display: flex;
  gap: 16px;
`;

const SizeInputRow = styled.div`
  display: flex;
  gap: 16px;
`;

const SizeInputGroup = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const SizeInput = styled.input`
  flex: 1;
  padding: 16px;
  border: 1px solid #e0e4eb;
  border-radius: 10px;
  font-size: 1rem;
  color: ${palette.gray700};

  &:focus {
    outline: none;
    border-color: ${palette.primary};
  }

  &::placeholder {
    color: ${palette.gray500};
  }
`;

const SizeUnit = styled.span`
  font-size: 14px;
  color: ${palette.gray600};
  min-width: 24px;
`;

const ButtonCenter = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const InfoBox = styled.div`
  background-color: ${palette.primaryLightest};
  border-radius: 8px;
  padding: 16px;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  // gap: 16px;
`;

const LargeButton = styled(Button)`
  width: 200px;
  padding: 16px 32px;
  font-size: 16px;
  min-height: 56px;
`;

const DirectInputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
`;

const ResetButton = styled.button`
  background: none;
  border: none;
  color: ${palette.gray400};
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;

  &:hover {
    background-color: ${palette.gray100};
    color: ${palette.gray700};
  }
`;

const ContentLink = styled.a`
  color: ${palette.primary};
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: ${palette.primary}DD;
    text-decoration: underline;
  }

  &:visited {
    color: ${palette.primary};
  }
`;

const CustomPopupSubtitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${palette.gray600};
  margin: 0;
  margin-bottom: 12px;
`;

const AddDisplayButton = styled.button`
  height: 32px;
  padding: 0 12px;
  background: transparent;
  border: 1px solid #e0e4eb;
  border-radius: 6px;
  color: #8a949e;
  font-size: 14px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 21px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;

  &:hover {
    background: #f9fafb;
    border-color: #cdd1d5;
  }
`;

const StatCardContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
